var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRoundVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.66675C11.6667 6.66675 4.55002 11.8501 1.66669 19.1667C4.55002 26.4834 11.6667 31.6667 20 31.6667C28.3334 31.6667 35.45 26.4834 38.3334 19.1667C35.45 11.8501 28.3334 6.66675 20 6.66675ZM20 27.5001C15.4 27.5001 11.6667 23.7667 11.6667 19.1667C11.6667 14.5667 15.4 10.8334 20 10.8334C24.6 10.8334 28.3334 14.5667 28.3334 19.1667C28.3334 23.7667 24.6 27.5001 20 27.5001ZM20 14.1667C17.2334 14.1667 15 16.4001 15 19.1667C15 21.9334 17.2334 24.1667 20 24.1667C22.7667 24.1667 25 21.9334 25 19.1667C25 16.4001 22.7667 14.1667 20 14.1667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRoundVisibility);
export default __webpack_public_path__ + "static/media/ic_round-visibility.933ecb2f63bdb364aa32eecf9f6f5635.svg";
export { ForwardRef as ReactComponent };